import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import "./index.css";

axios.defaults.baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // react strict mode is disabled coz it was rendering useEffect twice in fetching speaker
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);
